import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EstadisticasService {
  constructor(private httpClient: HttpClient) {}

  get(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/estadisticas');
  }
}
